export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement8.fa8f12bb.png";